"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _autoSuggestSearchModule = _interopRequireDefault(require("./autoSuggestSearch.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _searchIcon = _interopRequireDefault(require("../icons/searchIcon"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

require("../../../styles/autosuggest.css");

var _constants = require("../../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRequiredClassName = function getRequiredClassName(required, style) {
  if (!required) {
    return "";
  }

  return style === _constants.secondaryVariantStyle ? _autoSuggestSearchModule.default["required-secondary-label"] : _autoSuggestSearchModule.default["required-label"];
};

var AutoSuggestSearch = function AutoSuggestSearch(props) {
  var id = props.id,
      suggestions = props.suggestions,
      onSuggestionsFetchRequested = props.onSuggestionsFetchRequested,
      onSuggestionsClearRequested = props.onSuggestionsClearRequested,
      getSuggestionValue = props.getSuggestionValue,
      renderSuggestion = props.renderSuggestion,
      inputProps = props.inputProps,
      onSuggestionSelected = props.onSuggestionSelected,
      label = props.label,
      inputSize = props.inputSize,
      labelSize = props.labelSize,
      themes = props.themes,
      handleAutosuggestButton = props.handleAutosuggestButton,
      _props$autoSuggestTes = props.autoSuggestTestId,
      autoSuggestTestId = _props$autoSuggestTes === void 0 ? 'auto-suggest' : _props$autoSuggestTes,
      _props$autoSuggestInp = props.autoSuggestInputTestId,
      autoSuggestInputTestId = _props$autoSuggestInp === void 0 ? 'auto-suggest-input' : _props$autoSuggestInp,
      _props$autoSuggestLab = props.autoSuggestLabelTestId,
      autoSuggestLabelTestId = _props$autoSuggestLab === void 0 ? 'auto-suggest-label' : _props$autoSuggestLab,
      _props$requiredStyle = props.requiredStyle,
      requiredStyle = _props$requiredStyle === void 0 ? _constants.primaryVariantStyle : _props$requiredStyle;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group") : null,
    "data-testid": autoSuggestTestId,
    className: (0, _classnames.default)("row", _autoSuggestSearchModule.default["form-group"], "", _themeModule.default.arag)
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group_required_label") : null,
    className: "".concat(labelSize, " ").concat(getRequiredClassName(inputProps.required, requiredStyle)),
    "data-testid": autoSuggestLabelTestId
  }, label && _react.default.createElement("label", {
    id: id ? "".concat(id, "_form_group_label") : null,
    className: _autoSuggestSearchModule.default["control-label"]
  }, label)), _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group_size") : null,
    className: "".concat(inputSize)
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group_wrapper") : null,
    "data-testid": autoSuggestInputTestId
  }, _react.default.createElement("div", {
    onKeyDown: function onKeyDown(evt) {
      return evt.key === 'Enter' ? handleAutosuggestButton() : null;
    }
  }, _react.default.createElement(_reactAutosuggest.default, {
    suggestions: suggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: renderSuggestion,
    inputProps: inputProps,
    onSuggestionSelected: onSuggestionSelected,
    theme: themes
  })), _react.default.createElement("div", {
    onClick: handleAutosuggestButton
  }, _react.default.createElement(_searchIcon.default, {
    className: "ui-applicationsAndPolicies-autosuggest-search-icon",
    id: id ? "".concat(id, "_input_button_icon") : null
  }))))));
};

AutoSuggestSearch.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array of suggestions to display in the autosuggest dropdown */
  suggestions: _propTypes.default.array,

  /** Function to call when the autosuggest needs to fetch suggestions */
  onSuggestionsFetchRequested: _propTypes.default.func,

  /** Function to call when the autosuggest needs to clear suggestions */
  onSuggestionsClearRequested: _propTypes.default.func,

  /** Function to call when a suggestion is selected */
  onSuggestionSelected: _propTypes.default.func,

  /** Function to call when a suggestion is selected */
  getSuggestionValue: _propTypes.default.func,

  /** Function to call when a suggestion is selected */
  renderSuggestion: _propTypes.default.func,

  /** Object that specifies the input properties */
  inputProps: _propTypes.default.object,

  /** String text that specifies the label for the input */
  label: _propTypes.default.string,

  /** String text that specifies the size of the input */
  inputSize: _propTypes.default.string,

  /** String text that specifies the size of the label */
  labelSize: _propTypes.default.string,

  /** Object that specifies the theme for the autosuggest */
  themes: _propTypes.default.object,

  /** String text that specifies the test id for the autosuggest */
  autoSuggestTestId: _propTypes.default.string,

  /** String text that specifies the test id for the autosuggest label */
  autoSuggestLabelTestId: _propTypes.default.string,

  /** String indicating the style to be applied for required fields */
  requiredStyle: _propTypes.default.oneOf([_constants.primaryVariantStyle, _constants.secondaryVariantStyle])
};
var _default = AutoSuggestSearch;
exports.default = _default;